import CustomDropdown from '../../../components/dropdowns/dropdown';

export default function ELearningCoursesFilters({ filterBy, onFilterBy = () => {}, sortBy, onSortBy = () => {}, direction = {}, onDirection = () => {} }) {
    return (
        <div className="content-container__filters">
            <CustomDropdown items={[
                {
                    label: 'Reset',
                    value: null,
                },
                {
                    label: 'Name',
                    value: 'name'
                },
                {
                    label: 'Latest',
                    value: 'created_at'
                }
            ]} placeholder="Sort results by" value={sortBy} icon="sort" onChange={onSortBy}/>

            <CustomDropdown items={[
                {
                    label: 'Reset',
                    value: null,
                },
                {
                    label: 'Ascending',
                    value: 'asc'
                },
                {
                    label: 'Descending',
                    value: 'desc'
                }
            ]} placeholder="Sort Direction" icon="sort" value={direction} onChange={onDirection}/>

            <CustomDropdown items={[
                {
                    label: 'Reset',
                    value: null,
                },
                {
                    label: 'Public',
                    value: 'public'
                },
                {
                    label: 'Private',
                    value: 'private'
                },
                {
                    label: 'Active',
                    value: 'active'
                },
                {
                    label: 'Inactive',
                    value: 'inactive'
                }
            ]} placeholder="Filter results by" value={filterBy} icon="filter" onChange={onFilterBy}/>
    
            {/* <CustomDropdown items={[]} reset={true} placeholder="Catagories" icon="filter" value={acceptedRejected} onChange={onAcceptedRejected}/> */}
        </div>
    )
}